import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router';
import locationShape from 'react-router/lib/PropTypes';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { siteShape } from '@bibliocommons/bc-prop-types';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { Dropdown } from '@bibliocommons/base-dropdown';
import { TextButton } from '@bibliocommons/base-buttons';
import LibraryLogo from '@bibliocommons/shared-library-logo';

import './AccountSwitcher.scss';

export class AccountSwitcher extends BcReactComponent {
  getLinkForLibrary(library) {
    const { location } = this.props;
    return `${library.get('baseUrl')}${location.pathname}${location.search}`;
  }

  renderLibraryLogo(library) {
    return (
      <LibraryLogo
        key={`logo-${library.get('siteId')}`}
        siteId={library.get('siteId')}
        imageName="account_linking_image"
        small
        circled
        baseUrl={this.context.coreCdnHost || ''} />
    );
  }

  renderLibraryLogos() {
    return this.props.linkedLibrariesById.map(
      library => this.renderLibraryLogo(library)
    ).toArray();
  }

  renderLibraryLink(library) {
    return (
      <a className="library-link" href={this.getLinkForLibrary(library)}>
        {this.renderLibraryLogo(library)}
        {library.get('longName')}
      </a>
    );
  }

  renderLibraryLinks() {
    return this.props.linkedLibrariesById.map(
      library => <li key={`library-link-${library.get('siteId')}`}>{this.renderLibraryLink(library)}</li>
    ).toArray();
  }

  renderTriggerButtonContents() {
    return (
      <span>
        <span className="trigger-text" aria-hidden="true">
          <FormattedMessage id="switch_account" />
        </span>

        <ScreenReaderMessage>
          <FormattedMessage id="switch_account" />
        </ScreenReaderMessage>

        <div className="library-logos">
          {this.renderLibraryLogos()}
        </div>
      </span>
    );
  }

  render () {
    if (!this.props.linkedLibrariesById.isEmpty()) {
      return (
        <div className="cp-account-switcher">
          <Dropdown
            className=""
            disableMobile
            ButtonTag={TextButton}
            selected={this.renderTriggerButtonContents()}>
            {this.renderLibraryLinks()}
          </Dropdown>
        </div>
      );
    }

    return null;
  }

}

AccountSwitcher.propTypes = {
  linkedLibrariesById: ImmutablePropTypes.mapOf(siteShape),
  location: PropTypes.shape(locationShape)
};

export default withRouter(AccountSwitcher);



// WEBPACK FOOTER //
// ./app/components/borrowing/sidebar/AccountSwitcher/AccountSwitcher.jsx